import { AdyenAccountHolderAgreementStatus } from "../../adyenTypes"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Placement, StandardChip } from "../../../../../../../shared/components/badges/StandardChip"

export function AgreementStatusChip({
    status,
    placement,
}: {
    status: AdyenAccountHolderAgreementStatus
    placement: Placement
}) {
    switch (status) {
        case AdyenAccountHolderAgreementStatus.VALID:
            return (
                <LocalizedStrict id="adyen-account-holders-table-header-status-valid">
                    <StandardChip placement={placement} variant="success">
                        Valid
                    </StandardChip>
                </LocalizedStrict>
            )
        case AdyenAccountHolderAgreementStatus.INVALID:
            return (
                <LocalizedStrict id="adyen-account-holders-table-header-status-invalid">
                    <StandardChip placement={placement} variant="red">
                        Invalid
                    </StandardChip>
                </LocalizedStrict>
            )
        case AdyenAccountHolderAgreementStatus.PENDING:
            return (
                <LocalizedStrict id="adyen-account-holders-table-header-status-pending">
                    <StandardChip placement={placement} variant="yellow">
                        Pending
                    </StandardChip>
                </LocalizedStrict>
            )
        default:
            return (
                <StandardChip placement={placement} variant="grey">
                    Unknown
                </StandardChip>
            )
    }
}
